import React, {Dispatch, useState} from "react"
import {useAppDispatch, useAppSelector} from "../../../../hooks/redux"
import useWindowSize from "../../../../hooks/useWindowSize"
import {IBrigade} from "../../../../models/brigade"
import LineMenu from "../LineMenu"
import Modal from "../../modals/Modal"
import {deleteBrigade, fetchBrigades, setCurrentPage} from "../../../../store/actions/brigadeActions"
import ModalEditBrigade from "../../modals/ModalEditBrigade/ModalEditBrigade"
import StatusLabel from "../../../generic/dataDisplay/StatusLabel"
import classes from "./BrigadeLine.module.scss"

interface IBrigadeLineProps {
  brigade: IBrigade,
  editSuccess: Dispatch<any>
  deleteSuccess: Dispatch<any>
}

function BrigadeLine({brigade, editSuccess, deleteSuccess}: IBrigadeLineProps) {

  const dispatch = useAppDispatch()
  const windowSize = useWindowSize()
  const [modalEditShown, modalEditToggle] = useState(false)
  const [modalDeleteShown, modalDeleteToggle] = useState(false)
  const {pageSize} = useAppSelector(state => state.brigade)

  const deleteHandler = async () => {
    const isDeleted = await dispatch(deleteBrigade(brigade.id))

    if (isDeleted) {
      modalDeleteToggle(false)
      deleteSuccess(true)
      dispatch(setCurrentPage(1))
      await dispatch(fetchBrigades({page: 1, pageSize}))
    }
  }

  const modalEdit = modalEditShown &&
    <ModalEditBrigade
      close={() => modalEditToggle(false)}
      editSuccess={editSuccess}
      editableItem={brigade}
    />

  const modalDelete = modalDeleteShown &&
    <Modal
      title={"Удалить бригаду?"}
      close={() => modalDeleteToggle(false)}
      dialogSizeSuffix={"w350"}
      submitClick={deleteHandler}
      submitText={"Да, удалить"}
      cancelClick={() => modalDeleteToggle(false)}
      headerAlignCenter={true}
    />

  const employees = brigade.employees && brigade.employees.map(employee => <span className={classes.employee_item} key={employee.id}>{employee.name}</span>)

  const menuList = [
    {
      id: 1,
      text: "Редактировать",
      onClick: () => modalEditToggle(true)
    },
    {
      id: 2,
      text: "Удалить",
      type: "delete",
      onClick: () => modalDeleteToggle(true)
    }
  ]

  return (
    <>
      <div className={classes.wrap}>
        <div className={[classes.field, classes.field_name].join(" ")}>
          <div className={classes.field_value_name}>{brigade.brigade}</div>
        </div>
        <div className={[classes.field, classes.field_brigades].join(" ")}>
          {windowSize.width < 768 && <div className={classes.field_label}>{`Сотрудники`}</div>}
          {<div className={classes.employees}>
            {employees.length ? employees : `-`}
          </div>}
        </div>
        <div className={[classes.field, classes.field_status].join(" ")}>
          <StatusLabel id={brigade.status_id} type={"brigade"}/>
        </div>
        <div className={[classes.field, classes.field_menu].join(" ")}>
          <LineMenu items={menuList}/>
        </div>
      </div>
      {modalEdit}
      {modalDelete}
    </>
  )
}

export default BrigadeLine